/**
 * @voltxampere/ui — 7-segment common-anode display variant (Sprint 43-7, placeholder)
 *
 * PLACEHOLDER. Single-digit common-anode 7-segment LED display
 * (5161AH-class). Inverted polarity sibling of the common-cathode
 * 5161AS. Real visual rendering + per-segment simulation lands
 * Sprint 47+.
 *
 * Reference: Generic 5161AH / 5611AH class CA display. 7 cathode
 * pins + 1 anode pin + 1 decimal-point pin.
 *
 * Engine zero-diff invariant honored — canonical `voltage-source`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const display7segCa = {
    id: "7seg-ca",
    nameTr: "7 Segment Display (Ortak Anot, 5161AH, placeholder)",
    nameEn: "7-Segment Display (Common Anode, 5161AH, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "DS",
    defaultValue: "7SEG-CA",
    schemaType: "voltage-source",
    defaultParams: { voltage: 5 },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=display-7seg-ca.js.map